import { defineStore } from "pinia";
import { RegistrationService } from "~/services/RegistrationService";
import type { RegistrationStep0 } from "@/models/RegistrationStep0";

const CLEAR_STORAGE_DELAY = 300000;

export const useStep0Store = defineStore("step0", {
    state: () => {
        return {
            isLoading: false,
            emailAddress: ""
        };
    },
    persist: {
        storage: persistedState.localStorage
    },
    actions: {
        async postData(registrationStep0: RegistrationStep0): Promise<void> {
            try {
                this.isLoading = true;
                await RegistrationService.registerStep0(registrationStep0);
                this.emailAddress = registrationStep0.emailAddress;
                this.scheduleStorageClear();
            } catch (error) {
                this.isLoading = false;
                console.error(error);
                throw error;
            } finally {
                this.isLoading = false;
            }
        },
        scheduleStorageClear() {
            setTimeout(() => {
                localStorage.removeItem("pinia");
                this.emailAddress = "";
            }, CLEAR_STORAGE_DELAY);
        }
    }
});
